// extracted by mini-css-extract-plugin
var _1 = "ChatTableRowLastMessageDeleted-modulemessageDeletedText__mSnFV";
export { _1 as "messageDeletedText" }
